<template>
  <div>
    <md-card>
      <form>
        <md-card-header data-background-color="blue">
          <h4 class="title">Sign in</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>Email Address</label>
                <md-input v-model="emailadress" type="email" name="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Password</label>
                <md-input v-model="password" type="password" name="password"></md-input>
              </md-field>
            </div>


<div class="md-layout-item md-small-size-100 md-size-50">
    <div>
        <label>Captcha：</label>
        <div id="captcha">
          <i id="captcha_spinner" class="fa fa-spinner fa-spin"></i>
  
        </div>
    </div>
</div>    




            <div class="md-layout-item md-small-size-100 md-size-50">              
                <md-button  id="login_btn" type="button" v-on:click="Login()" class="md-raised md-success disabled">Login</md-button>              
            </div>
          </div>
        </md-card-content>
      </form>
    </md-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { API } from "../../services/";
import { store } from '../../store/index';

export default {
  name: "login-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      disabled: null,
      emailadress: null,
      password: null,
      captcha: {},
      captcha_result: null,
      captchaObj: null,
    };
  },
  created: function () {
    API.captchaRegister().then((response)=> 
        {
          this.captcha = response.data                    
          if (typeof window.initGeetest !== 'function') {
                    const URL = 'https://swarm.video/gt.js';
                    const scriptHeat = document.createElement('script');
                    scriptHeat.type = 'text/javascript';
                    scriptHeat.src = URL;
                    document.body.appendChild(scriptHeat);
                    scriptHeat.onload = () => {
                         this.StartGeetest();
                    }
              }
          else {
            this.StartGeetest();
          }

        }
    )    
  },
  methods: {
    ...mapActions(["SET_JWTOKEN", "SET_USERDATA","SET_SOURCES"]),
    Redirect() {
      this.$router.push("dashboard");
    },
    StartGeetest() {      
        initGeetest({
            // 以下 4 个配置参数为必须，不能缺少
            gt: this.captcha.gt,
            challenge: this.captcha.challenge,
            offline: !this.captcha.success, // 表示用户后台检测极验服务器是否宕机
            new_captcha: this.captcha.new_captcha, // 用于宕机时表示是新验证码的宕机
            lang: 'en',
            product: "popup", // 产品形式，包括：float，popup
            width: "300px",
            https: true            
        }, this.GeetestHandler)
    },
    GeetestHandler(captchaObj){      
      this.captchaObj= captchaObj
      this.captchaObj.appendTo('#captcha');
      //let res = captchaObj.getValidate()        
       this.captchaObj.onReady(function () {
            $("#login_btn").removeClass('disabled');
            $("#captcha_spinner").hide()
        });

    },
    Login() {
      this.captcha_result = this.captchaObj.getValidate()
       if (!this.captcha_result) {
         let notification = {
              message: 'ups we need captcha to avoid Bots',
              status: '429',
              datetime: new Date().toLocaleString()
            }    
                return store.dispatch('SET_NOTIFICATION', notification);
            }
      
            
      
      API.doLogin(this.emailadress, this.password, 
                  this.captcha_result.geetest_challenge,
                  this.captcha_result.geetest_validate ,
                  this.captcha_result.geetest_seccode)
      .then(response => {
        if (response.data.success) {          
          this.SET_JWTOKEN(response.data.data.accessToken);
          this.SET_USERDATA(response.data.data.userData);
          this.SET_SOURCES(response.data.data.sources);
          setTimeout(this.Redirect, 2500);
        } else {
          this.response_error = response.data.message;
        }
      });
    }
  }
};
</script>
